import PackagePreview from "@/components/admin/view/package/PackagePreview";
import PackageCreatePage from "./pages/PackageCreatePage";
import PackageDetailPage from "./pages/PackageDetailPage";
import PackageListPage from "./pages/PackageListPage";
import PackageOrderingPage from "./pages/PackageOrderingPage";

export const packageRoutes = (prefix = "packages") => [
  {
    name: "PackageCreatePage",
    path: `${prefix}/create`,
    component: PackageCreatePage
  },
  {
    name: "PackageOrderingPage",
    path: `${prefix}/ordering`,
    component: PackageOrderingPage
  },
  {
    name: "PackagePreviewPage",
    path: `${prefix}/preview/:packageId`,
    component: PackagePreview
  },
  {
    name: "PackageDetailPage",
    path: `${prefix}/:id`,
    component: PackageDetailPage
  },
  { name: "PackageListPage", path: prefix, component: PackageListPage }
];

export const previewPackageRoutes = {
  path: "packages/preview/:packageId",
  name: "PackagePreview",
  component: PackagePreview
};
